export default __webpack_public_path__ + "static/quote-video-3-462c65c1b0846839a00407ec09f7a262.mp4";